module.exports = __webpack_public_path__ + "img/電気回路_5_4_4.ff984781.png";